import React from 'react';
import {Box, Button, Card, CardContent, Grid2, TextField, Typography} from "@mui/material";
import palette from "../../../../../theme/palette";
import {LoadingButton} from "@mui/lab";
import dayjs from "dayjs";
import { api } from '../../../../../http';
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";

interface Props {
    fileName:string;
    selectedFile:File|undefined;
    setFileName:(name:string)=>void;
    handleBack:()=>void;
}

export const FileNameInput: React.FC<Props> = ({selectedFile,fileName,setFileName,handleBack}) => {

    const [isLoading, setLoading] = React.useState(false);
    const navigate = useNavigate();

    const generateReport = async ()=>{
        setLoading(true);
        const formData = new FormData();
        formData.append('csvFile', selectedFile as File);
        try {
            // Call to your TypeScript backend
            await api.post('/reports/getBulkSafetyReport', formData, {
                responseType: 'blob' // Important for receiving binary data
            }).then((response)=>{
                if(response){
                    // Create download link
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${fileName.replaceAll(" ","-")}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    toast('Bulk Safety Report generated successfully', {
                        autoClose: false,
                        type: 'success',
                    });
                    handleBack();
                }
            })
                .catch((error)=>{
                    toast('Error generating bulk report.', {
                        autoClose: false,
                        type: 'error',
                    });
                });
        } catch (error) {
            console.error('Error converting file:', error);
        } finally {
            setLoading(false);
        }
    }

    const onCancel = ()=>{
        setFileName('');
        setLoading(false);
    }

    const defaultFileName = dayjs().format('MMMM D, YYYY') + ' Bulk Safety Report';
    return (
        <Grid2 container justifyContent={'center'} alignItems={'center'}>
            <Grid2 size={{md:6,xs:12}}>
                <Card>
                    <CardContent sx={{padding:3}}>
                        <Typography fontWeight={500} fontSize={18} sx={{mb:2}}>
                            Name your Bulk Safety Report
                        </Typography>
                        <Box sx={{mb:3}}>
                            <Typography fontWeight={400} fontSize={16} color={'text.secondary'}>
                                Give your report a unique name so you can find it later
                            </Typography>
                        </Box>
                        <Box sx={{mb:{md:30,xs:10}}}>
                            <TextField
                                size="medium"
                                value={fileName}
                                placeholder={defaultFileName}
                                fullWidth
                                onChange={(e)=>setFileName(e.target.value)}
                            />
                        </Box>
                        <Grid2
                            marginTop={20}
                            flexDirection={'row-reverse'}
                            container
                            spacing={2}
                            mt={3}
                        >
                            <LoadingButton loading={isLoading} sx={{color:palette.darkBlue}} onClick={generateReport} disabled={!selectedFile || fileName.length === 0} autoFocus>
                                Submit
                            </LoadingButton>
                            <Button disabled={false} color="inherit" onClick={onCancel}>
                                Cancel
                            </Button>
                        </Grid2>
                    </CardContent>
                </Card>
            </Grid2>
        </Grid2>
    )
}